import React, { useState, useEffect, useMemo } from 'react';
import { useCollection } from '../../hooks/useCollection';
import { Link } from "react-router-dom";
import ProjectSort from '../../components/sortedValues/ProjectSort';
import '../../components/ProjectList.css';
import { categories } from '../create/Create';
import { timestamp } from '../../firebase/config';
import './futureAssignments/FutureAssignments.css';

const ProjectFutureAssignment = () => {
    const today = timestamp.fromDate(new Date());
    const { documents, error } = useCollection('projects', 'liveDate', '>', today, 'liveDate', 'desc');

    const [filtered, setFiltered] = useState('All');

    // Load saved sort preference from localStorage
    const [sortBy, setSortBy] = useState(() => {
        const savedSort = localStorage.getItem('futureAssignmentsSortPreference');
        return savedSort || 'liveDate-asc';
    });

    // Save sort preference to localStorage whenever it changes
    useEffect(() => {
        localStorage.setItem('futureAssignmentsSortPreference', sortBy);
    }, [sortBy]);

    const customSearch = (e) => {
        setFiltered(e.target.id);
    };

    // Filter and sort future assignments
    const sortedProjects = useMemo(() => {
        if (!documents) return [];

        // Filter by category if not "All"
        const categoryFiltered = filtered === 'All' 
            ? documents 
            : documents.filter(project => project.category === filtered);

        // Sort based on sortBy preference
        return categoryFiltered.sort((a, b) => {
            switch (sortBy) {
                case "liveDate-asc":
                    return a.liveDate.toDate() - b.liveDate.toDate();
                case "liveDate-desc":
                    return b.liveDate.toDate() - a.liveDate.toDate();
                case "dueDate-asc":
                    return a.dueDate.toDate() - b.dueDate.toDate();
                case "dueDate-desc":
                    return b.dueDate.toDate() - a.dueDate.toDate();
                case "createdAt-asc":
                    return a.createdAt.toDate() - b.createdAt.toDate();
                case "createdAt-desc":
                    return b.createdAt.toDate() - a.createdAt.toDate();
                case "category":
                    return a.category.localeCompare(b.category);
                case "title":
                    return a.title.localeCompare(b.title);
                default:
                    return 0;
            }
        });
    }, [documents, filtered, sortBy]);

    return (
        <div className="future-assignments-page">
            <div className="page-header">
                <h2 className="page-title">Future Homework Assignments</h2>
                <ProjectSort sortBy={sortBy} onSortChange={setSortBy} />
            </div>

            {error && <p className="error">{error}</p>}

            {/* Category Filter */}
            <ul className='category-list'>
                <li>
                    <span 
                        onClick={customSearch} 
                        id='All'
                        className={filtered === 'All' ? 'active' : ''}
                    >
                        All
                    </span>
                </li>
                {categories.map(category => (
                    <li key={category.value}>
                        <span 
                            onClick={customSearch} 
                            id={category.label}
                            className={filtered === category.label ? 'active' : ''}
                        >
                            {category.label}
                        </span>
                    </li>
                ))}
            </ul>

            <div className="project-list">
                {sortedProjects.length === 0 && <p>No future assignments!</p>}
                {sortedProjects.map(project => (
                    <Link to={`/projects/${project.id}`} key={project.id}>
                        <h4 style={{ textTransform: 'capitalize' }}>{project.title}</h4>
                        <p style={{ textTransform: 'capitalize' }}>{project.category}</p>
                        <div id="project-dates">
                            <p className="live-date">
                                📅 Goes Live: {project.liveDate.toDate().toDateString()}
                            </p>
                            <p>Due: {project.dueDate.toDate().toDateString()}</p>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default ProjectFutureAssignment;